"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultTable = ResultTable;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const pagination_1 = require("@genesys/client-core/lib/pagination");
function ResultTable({ results, columns, itemsPerPage = 25, refreshCallback }) {
    const [state, setState] = React.useState({
        currentPage: 1
    });
    return (React.createElement("div", null,
        React.createElement(pagination_1.PaginationComponent, { currentPage: state.currentPage, itemsPerPage: itemsPerPage, numberOfPages: Math.ceil(results.length / itemsPerPage), onPageChange: pageNumber => {
                setState({
                    currentPage: pageNumber
                });
            }, onRefresh: () => {
                if (refreshCallback) {
                    refreshCallback();
                }
            }, totalItems: results.length }),
        React.createElement(Elements.DataPresenterTable, null,
            React.createElement("thead", null,
                React.createElement("tr", null, columns.map((column, index) => (React.createElement("th", { key: index }, column.header))))),
            React.createElement("tbody", null, results
                .slice((state.currentPage - 1) * itemsPerPage, state.currentPage * itemsPerPage)
                .map((row, rowIndex) => (React.createElement("tr", { key: rowIndex }, columns.map((column, colIndex) => (React.createElement("td", { key: colIndex }, column.rowRenderer(row)))))))))));
}
//# sourceMappingURL=result-table.js.map